// extracted by mini-css-extract-plugin
export default {"address":"style_address__jatmP","address1":"style_address1__qLdlA","address2":"style_address2__ewp3x","city":"style_city__eAzdi"};